import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { isUndefined } from 'lodash';
import React, { Fragment } from 'react';
import withTranslations from '../../utils/HighOrderComponent';
import ErrorLabel from './ErrorLabel';

const RadioGroupField = (props) => {
  const {
    data,
    value,
    row,
    onChange,
    name,
    error,
    errorsHandler,
    margin = 'normal',
    label,
    disabled,
    inlineLabel,
    defaultValue,
    required,
    gt,
    classNameRadio,
  } = props || {};
  const errorMessage = error?.[name];
  const hasError = !isUndefined(errorMessage);

  const errorRemovalHandler = () => {
    errorsHandler((prevError) => {
      delete prevError[name];
      return prevError;
    });
  };
  const className =
    (!!inlineLabel &&
      `d-flex flex-row justify-content-between align-items-center ${classNameRadio}`) ||
    '';

  return (
    <Fragment>
      <FormControl
        error={hasError}
        margin={margin}
        variant="standard"
        disabled={!!disabled}
        className={className}
      >
        <FormLabel required={!!required} id={name}>
          {label}
        </FormLabel>
        <RadioGroup
          aria-labelledby={name}
          value={value}
          name={name}
          row={!!row}
        >
          {!!defaultValue && (
            <FormControlLabel
              key={`0_0`}
              value={0}
              control={<Radio />}
              label={gt.RadioButtonGroup.default}
              onChange={(event) => {
                onChange(event);
                hasError && errorRemovalHandler();
              }}
            />
          )}
          {data?.map((item, index) => (
            <FormControlLabel
              key={`${item.id}_${index}`}
              value={item.value}
              control={<Radio />}
              label={item.label}
              onChange={(event) => {
                onChange(event);
                hasError && errorRemovalHandler();
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <ErrorLabel error={errorMessage} />
    </Fragment>
  );
};

export default withTranslations(RadioGroupField);
